import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKgVideoPlaceholder = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeWidth: 2,
		fill: "none",
		stroke: "currentColor",
		strokeLinejoin: "round",
		className: "nc-icon-wrapper",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 2,
				y: 18,
				width: 31,
				height: 26,
				rx: 4
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 8.5,
				cy: 7.5,
				r: 5.5
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 25.5,
				cy: 9.5,
				r: 3.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-cap": "butt",
				d: "m33 27 13-6v20l-13-6"
			})
		]
	})
});
export default SvgKgVideoPlaceholder;
